export class DobryPradFormData {
  public contactConsent: boolean;
  public passCurrentAgreementTermsConsent: boolean;
  public phoneNumber: string;

  constructor(contactConsent: boolean, passCurrentAgreementTermsConsent: boolean, phoneNumber: string) {
    this.contactConsent = contactConsent;
    this.passCurrentAgreementTermsConsent = passCurrentAgreementTermsConsent;
    this.phoneNumber = phoneNumber;
  }

}
